<template>
    <v-tooltip :text="$t('visibility_in_order_eye_tooltip')">
        <template v-slot:activator="{props}">
            <v-btn
                v-if="$conf.public.account.visibilityInReservationEye"
                v-bind="props"
                size="small"
                variant="text"
                density="comfortable"
                color="inherit"
                :icon="visibleInReservation ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                :loading="visibleInReservationLoading"
                @click.stop="setVisibleInReservation"
            />
        </template>
    </v-tooltip>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class OrderVisibleInReservationBtn extends Vue {
        @Prop() visibleInReservation
        @Prop() processId
        @Prop() orderId

        visibleInReservationLoading = false

        async setVisibleInReservation() {
            try {
                this.visibleInReservationLoading = true
                await this.$api.orders.put(this.orderId, {
                    servicesVisible: [
                        {
                            visibleInReservation: !this.visibleInReservation,
                            processId: this.processId,
                        },
                    ],
                })

                await runtimeStore.refreshOrder()
            } catch (e) {
                this.$toast.error(this.$t('error_message.save_error'))
            } finally {
                this.visibleInReservationLoading = false
            }
        }
    }

    export default OrderVisibleInReservationBtn
</script>
